import { useEffect, useRef, useState } from 'react';
import './About.css';
import SkillsTerminal from './SkillsTerminal';

function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setInView(true); obs.disconnect(); }
    }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

const services = [
  { icon: '⬡', label: 'Applications web React', sub: 'Dashboard, SaaS, back-office' },
  { icon: '⬡', label: 'Applications mobiles', sub: 'React Native, iOS & Android' },
  { icon: '⬡', label: 'Intégration API & Auth', sub: 'REST, JWT, services tiers' },
  { icon: '⬡', label: 'Maintenance & Refactoring', sub: 'Reprise, corrections, évolutions' },
];

export default function About() {
  const [ref, inView] = useInView();

  return (
    <section className="about section" id="about" ref={ref}>
      <div className={`about__inner${inView ? ' is-visible' : ''}`}>
        <p className="section__label">À propos</p>
        <h2 className="section__title">
          Passionné par le <span className="keyword">code</span>{' '}
          et les <span className="keyword">solutions</span>
        </h2>
        <p className="about__bio">
          Vous cherchez un développeur capable de <span className="keyword">livrer rapidement</span>,
          de reprendre un projet existant ou de construire une application{' '}
          <span className="keyword">fiable et maintenable</span> ?
        </p>
        <p className="about__bio">
          J'interviens sur des projets web et mobile (React, React Native, API, authentification,
          refactoring, mise en production). Mon approche est{' '}
          <span className="keyword">pragmatique et orientée résultat</span> : un code lisible,
          documenté, facile à reprendre. Je m'adapte à votre stack et à vos contraintes,
          que ce soit pour une mission courte, un renfort d'équipe ou un développement from scratch.
        </p>
        <div className="services-grid">
          {services.map(({ label, sub }) => (
            <div key={label} className="service-item">
              <p className="service-item__label">{label}</p>
              <p className="service-item__sub">{sub}</p>
            </div>
          ))}
        </div>
        <p className="section__label" style={{ marginTop: '64px' }}>Compétences</p>
        <p className="about__terminal-hint">
          Explore mes compétences via le terminal : clique sur une commande ou tape la tienne.
        </p>
        <SkillsTerminal />
      </div>
    </section>
  );
}
